import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { HttpErrorHandler } from 'app/shared/http-error-handler';
import { List } from 'app/shared/list';

import { Document, DocumentFilter } from 'app/_models/document';
import { DocumentService } from 'app/_services/document.service';

declare var $: any;

@Component({
  selector: 'app-documents',
  templateUrl: './document-list.component.html',
  styleUrls: ['./document-list.component.scss'],
})
export class DocumentListComponent extends List implements OnInit {
  documentToDelete: Document | null = null;
  filter: DocumentFilter = new DocumentFilter();
  loading: boolean;

  constructor(
    private documentService: DocumentService,
    protected router: Router,
    protected route: ActivatedRoute,
    protected httpErrorHandler: HttpErrorHandler
  ) {
    super(documentService, new Document(), router, route);
  }

  ngOnInit() {
    this.loading = true;
    this.initList('documents', this.filter).then((result) => {
      this.loading = false;
    });
  }

  prepareDelete(document: Document) {
    this.documentToDelete = document;
  }

  deleteDocument(doc: Document) {
    if (this.documentToDelete) {
      this.documentService.delete(this.documentToDelete.id).subscribe(
        () => {
          $('#deleteModal').modal('hide');
          this.list(this.currentPage);
          this.documentToDelete = null;
        },
        (error) => {
          this.httpErrorHandler.handleHttpError(error);
          $('#deleteModal').modal('hide');
        }
      );
    }
  }
  applyFilter(params) {
    this.router.navigate(['/documents', params]);
  }
}



// WEBPACK FOOTER //
// ./src/app/documents/document-list/document-list.component.ts